// Legal content for LadyArt — GDPR-aligned, written to match the site's tone.
import { PHONE_DISPLAY, ADDRESS } from "./content";

export const LEGAL_LAST_UPDATED = "29 iulie 2026";

const PRIVACY = {
    slug: "politica-confidentialitate",
    eyebrow: "Legal",
    title: "Politică de confidențialitate",
    sections: [
        {
            n: 1,
            title: "Operatorul datelor",
            body: [
                `Acest site este operat de salonul de coafură LadyArt, cu sediul în ${ADDRESS}.`,
                `LadyArt (denumit în continuare „noi" sau „salonul") acționează în calitate de operator de date cu caracter personal, în conformitate cu Regulamentul (UE) 2016/679 (GDPR). Pentru orice întrebare legată de datele tale personale ne poți contacta prin telefon sau WhatsApp la ${PHONE_DISPLAY}.`,
            ],
        },
        {
            n: 2,
            title: "Ce date colectăm",
            body: [
                "Acest site este unul de prezentare. Nu are conturi de utilizator, formulare de rezervare online sau plăți.",
                "Colectăm date personale doar atunci când ne contactezi direct, și anume:",
                {
                    list: [
                        "numele tău (transmis prin WhatsApp sau telefon)",
                        "numărul de telefon",
                        "adresa de email — doar dacă alegi să ne-o trimiți voluntar",
                    ],
                },
                "Nu colectăm și nu solicităm date cu caracter sensibil.",
            ],
        },
        {
            n: 3,
            title: "Scopul prelucrării",
            body: [
                "Folosim aceste date exclusiv pentru:",
                {
                    list: [
                        "a răspunde solicitărilor tale de programare sau de informare",
                        "a comunica detalii despre servicii, disponibilitate și prețuri",
                        "a menține legătura cu tine în legătură cu programarea ta",
                    ],
                },
                "Nu folosim datele tale pentru marketing automat și nu le vindem sau închiriem către terți.",
            ],
        },
        {
            n: 4,
            title: "Temeiul legal (GDPR)",
            body: [
                "Prelucrăm datele pe baza următoarelor temeiuri legale:",
                {
                    list: [
                        "consimțământul tău, atunci când ne contactezi voluntar (art. 6 alin. 1 lit. a GDPR)",
                        "efectuarea de demersuri la cererea ta înainte de prestarea serviciului (art. 6 alin. 1 lit. b GDPR)",
                        "interesul nostru legitim de a răspunde mesajelor și de a gestiona programările (art. 6 alin. 1 lit. f GDPR)",
                    ],
                },
            ],
        },
        {
            n: 5,
            title: "Perioada de stocare",
            body: [
                "Păstrăm datele tale doar atât timp cât este necesar pentru scopul comunicării — de regulă pe durata relației cu tine în calitate de client și o perioadă rezonabilă ulterioară.",
                "Conversațiile purtate prin telefon sau WhatsApp rămân stocate în aplicațiile respective până când sunt șterse de tine sau de noi. Poți solicita oricând ștergerea datelor tale.",
            ],
        },
        {
            n: 6,
            title: "Dezvăluirea datelor",
            body: [
                "Nu transmitem datele tale către terți, cu excepția furnizorilor de servicii prin care alegi să comunici cu noi (de exemplu WhatsApp / Meta Platforms), care prelucrează datele conform propriilor politici de confidențialitate.",
            ],
        },
        {
            n: 7,
            title: "Drepturile tale",
            body: [
                "Conform GDPR, ai următoarele drepturi:",
                {
                    list: [
                        "dreptul de acces la datele tale",
                        "dreptul la rectificarea datelor inexacte",
                        "dreptul la ștergerea datelor („dreptul de a fi uitat”)",
                        "dreptul la restricționarea prelucrării",
                        "dreptul de opoziție la prelucrare",
                        "dreptul la portabilitatea datelor",
                        "dreptul de a-ți retrage consimțământul în orice moment",
                        "dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)",
                    ],
                },
            ],
        },
        {
            n: 8,
            title: "Cookie-uri",
            body: [
                {
                    link: {
                        before:
                            "Acest site utilizează un număr minim de cookie-uri, în principal tehnice, necesare funcționării. Detalii complete găsești în ",
                        label: "Politica de Cookies",
                        to: "/politica-cookies",
                        after: ".",
                    },
                },
            ],
        },
        {
            n: 9,
            title: "Contact pentru solicitări GDPR",
            body: [
                `Pentru exercitarea drepturilor tale sau pentru orice solicitare privind datele personale, ne poți contacta prin telefon sau WhatsApp la ${PHONE_DISPLAY}.`,
            ],
        },
    ],
};

const COOKIES = {
    slug: "politica-cookies",
    eyebrow: "Legal",
    title: "Politică de Cookies",
    sections: [
        {
            n: 1,
            title: "Ce sunt cookie-urile",
            body: [
                "Cookie-urile sunt fișiere text de mici dimensiuni salvate pe dispozitivul tău atunci când vizitezi un site web. Ele ajută site-ul să funcționeze corect și să rețină anumite preferințe.",
            ],
        },
        {
            n: 2,
            title: "Ce cookie-uri folosim",
            body: [
                "Site-ul LadyArt folosește în prezent doar cookie-uri tehnice (esențiale), necesare pentru afișarea corectă a paginilor.",
                "În acest moment NU folosim Google Analytics, Meta Pixel sau alte instrumente de urmărire în scop publicitar.",
            ],
        },
        {
            n: 3,
            title: "Cookie-uri de la servicii integrate",
            body: [
                "Anumite servicii pe care le integrăm pot seta propriile cookie-uri:",
                {
                    list: [
                        "Google Maps — harta cu locația salonului poate seta cookie-uri Google",
                        "Instagram / Facebook — atunci când accesezi linkurile către paginile noastre, ești redirecționat către aceste platforme, care folosesc propriile cookie-uri",
                    ],
                },
                "Aceste cookie-uri sunt guvernate de politicile de confidențialitate ale furnizorilor respectivi.",
            ],
        },
        {
            n: 4,
            title: "Cum poți gestiona cookie-urile",
            body: [
                "Poți controla și șterge cookie-urile din setările browserului tău:",
                {
                    list: [
                        "Google Chrome: Setări → Confidențialitate și securitate → Cookie-uri",
                        "Safari: Preferințe → Confidențialitate",
                        "Mozilla Firefox: Setări → Confidențialitate și securitate",
                    ],
                },
                "Dezactivarea cookie-urilor esențiale poate afecta funcționarea corectă a site-ului.",
            ],
        },
        {
            n: 5,
            title: "Actualizări",
            body: [
                "Putem actualiza periodic această politică. Orice modificare va fi publicată pe această pagină, împreună cu data ultimei actualizări.",
            ],
        },
    ],
};

const TERMS = {
    slug: "termeni-conditii",
    eyebrow: "Legal",
    title: "Termeni și condiții",
    sections: [
        {
            n: 1,
            title: "Despre acest site",
            body: [
                "Site-ul LadyArt este un site de prezentare. Informațiile publicate au caracter pur informativ și pot fi modificate oricând, fără notificare prealabilă.",
            ],
        },
        {
            n: 2,
            title: "Programări",
            body: [
                "Site-ul nu permite rezervări sau plăți online. Programările se realizează exclusiv prin telefon sau WhatsApp, la numărul afișat pe site.",
            ],
        },
        {
            n: 3,
            title: "Prețuri și servicii",
            body: [
                "Prețurile și descrierile serviciilor au caracter orientativ. Prețul final poate varia în funcție de lungimea și starea părului, produsele folosite și complexitatea lucrării și se confirmă în salon înainte de începerea serviciului.",
            ],
        },
        {
            n: 4,
            title: "Proprietate intelectuală",
            body: [
                "Toate fotografiile, textele și elementele grafice de pe acest site aparțin salonului LadyArt sau sunt folosite cu acordul deținătorilor de drepturi.",
                "Conținutul nu poate fi copiat, reprodus, distribuit sau utilizat în alt scop fără acordul scris prealabil al salonului.",
            ],
        },
        {
            n: 5,
            title: "Limitarea răspunderii",
            body: [
                "Depunem eforturi pentru ca informațiile de pe site să fie corecte și actuale, însă nu oferim garanții în acest sens. Nu ne asumăm răspunderea pentru eventuale decizii luate exclusiv pe baza informațiilor de pe site.",
            ],
        },
        {
            n: 6,
            title: "Linkuri externe",
            body: [
                "Site-ul poate conține linkuri către platforme externe (Instagram, Facebook, Google Maps). Nu suntem responsabili pentru conținutul sau politicile acestor site-uri terțe.",
            ],
        },
        {
            n: 7,
            title: "Legea aplicabilă",
            body: [
                "Prezentele condiții sunt guvernate de legislația română. Eventualele litigii pot fi soluționate pe cale amiabilă sau prin intermediul platformelor ANPC (SAL) și SOL.",
            ],
        },
        {
            n: 8,
            title: "Contact",
            body: [
                `Pentru orice întrebare legată de acești termeni, ne poți contacta prin telefon sau WhatsApp la ${PHONE_DISPLAY}.`,
            ],
        },
    ],
};

export const LEGAL_DOCS = {
    "politica-confidentialitate": PRIVACY,
    "politica-cookies": COOKIES,
    "termeni-conditii": TERMS,
};

export const LEGAL_LINKS = [
    { label: "Politică de confidențialitate", to: "/politica-confidentialitate" },
    { label: "Politică Cookies", to: "/politica-cookies" },
    { label: "Termeni și condiții", to: "/termeni-conditii" },
];
